module.exports = __webpack_public_path__ + "img/truerix_gold.e3065721.jpg";